import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import { LayoutFacade } from '@web/store/layout/layout.facade';
import { DeviceMode } from '@common/types/layout.type';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'web-device-toggle',
    templateUrl: './web-device-toggle.component.html',
    styleUrls: ['./web-device-toggle.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class WebDeviceToggleComponent {
    private readonly layoutFacade: LayoutFacade = inject(LayoutFacade);

    public readonly deviceMode$: Observable<DeviceMode> = this.layoutFacade.deviceMode$;
    public readonly isDeviceMobile$: Observable<boolean> = this.layoutFacade.isDeviceMobile$;
    public readonly isDeviceTablet$: Observable<boolean> = this.layoutFacade.isDeviceTablet$;
    public readonly isDeviceDesktop$: Observable<boolean> = this.layoutFacade.isDeviceDesktop$;

    public readonly deviceMode = DeviceMode;

    public changeDeviceMode(deviceMode: DeviceMode): void {
        this.layoutFacade.changeDeviceMode(deviceMode);
    }
}
